import React from "react"

import {Select} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import {useIntl} from "@irati/utils/lang"
import {DEFAULT_OPTIONS, PUBLISH_CUSTOMIZATION_PROPERTY} from "@irati/recognition/constants/publishCustomization"

interface Props {
  id: string
  value: string
  label: string
  placeholder: string
  onChange: () => void
}
const PublishCustomization = (props: Props) => {
  const {value, onChange, ...otherProps} = props
  const {formatMessage} = useIntl()
  const handleChange = (val, option) => {
    return onChange(option)
  }
  return (
    <Select
      options={DEFAULT_OPTIONS(formatMessage)}
      {...otherProps}
      onChange={handleChange}
      isSearchable={false}
      isClearable={false}
      id={id(PUBLISH_CUSTOMIZATION_PROPERTY, props)}
      name={id(PUBLISH_CUSTOMIZATION_PROPERTY, props)}
      value={value}
    />
  )
}

PublishCustomization.defaultProps = {
  label: "platform.fields.publishCustomization.label",
  placeholder: "platform.fields.publishCustomization.label",
  id: "publishCustomization"
}
export default PublishCustomization
